(function() {
    'use strict';

    angular.module("imApp").factory("textileSizesService", [function() {
        var service = {

        }

        return service;
    }]);
})();
